import React from 'react'
import PropTypes from 'prop-types'
import differenceInDays from 'date-fns/differenceInDays'
import differenceInCalendarYears from 'date-fns/differenceInCalendarYears'


import { SL_GATE } from 'Defaults/modals'

import { formatPrice } from 'Utils/inputUtils'

import { COMPARE_GA_CATEGORY } from 'Components/CompareGrid'

import SvgIcon from 'Components/SvgIcon'
import ListingBanner from 'Components/ListingBanner'
import { checkIsArchive } from 'Utils'
import { createPhotoPaths } from 'Utils/photoUtils'


import {
  _ListingCard, _InnerCard,
  _ImageHolder, _ImagePlaceholder, _LockedOverlay, _ListingPrice, _ListingTitle,
  _Counter, _RemoveCta, _FormattedPriceSpan,
} from './styles'

const ListingCard = ({
  listing, removeCompareListing, className, userIsAuthentificated,
  openRegisterModal, handleGalleryAndMap, googleAnalyticsEvent,
}) => {
  const {
    photo_base_url: photoBaseUrl, mls_number: mlsNumber,
    closed_price: closedPrice, asking_price: askingPrice,
    status, entry_date_unix: entryDateUnix, end_date_unix: endDateUnix,
    banner_id: bannerId, offer, featured,
    advertise_permission: advertisePermission,
    title, url, address,
    photo_source: photoSource,
    photo_version: photoVersion,
  } = listing || {}

  if(!mlsNumber) {
    return (
      <_ListingCard key={listing} className={className}>
        <_Counter>{listing}/8</_Counter>
      </_ListingCard>
    )
  }

  const firstPhotoObj = createPhotoPaths({
    photoBaseUrl,
    mlsNumber,
    photoIndex: 1,
    photoVersion,
    photoSource,
  })

  const imgUrl = mlsNumber ? firstPhotoObj.imgSmall : ''
  const price = askingPrice
  const listedDays = entryDateUnix ? differenceInDays(new Date(), new Date(entryDateUnix * 1000)) : null
  const isArchived = checkIsArchive(status)
  const archivedYears = endDateUnix ?
    differenceInCalendarYears(new Date(), endDateUnix * 1000) :
    null
  const isListingLocked = advertisePermission === 0
  const showLockedStyled = !userIsAuthentificated && (isArchived || isListingLocked)
  const isPrecon = listing?.offer === 'Precon'
  const isPreconFloorplan = isPrecon && listing?.property_type === 'Floorplan'
  const isAskingPriceAvailable = Number.isFinite(price) && price > 0
  const streetSuffix =
  `${address?.street_number || listing?.street_number || ''} ${address?.street_name_short || listing?.street_name_short || ''}`

  return (
    <_ListingCard key={mlsNumber} className={className}>
      <_InnerCard>
        <_ImageHolder
          hasHandler={handleGalleryAndMap}
          onClick={!showLockedStyled ? () => {
            if(handleGalleryAndMap) handleGalleryAndMap(listing, false)
          } : null}
        >
          <_ImagePlaceholder src={imgUrl} alt={title} />

          {
            showLockedStyled ?
              <_LockedOverlay
                onClick={() => {
                  openRegisterModal({ modalData: { gate: SL_GATE.COMPARE_LISTING_CARD } })
                }}
              >
                Create an account
              </_LockedOverlay>
              :
              <ListingBanner
                isArchived={isArchived}
                listedDays={listedDays}
                archivedYears={archivedYears}
                endDateUnix={endDateUnix}
                bannerId={userIsAuthentificated ? bannerId || 0 : 0}
                offer={offer}
                status={status}
                featured={!!(featured)}
              />
          }

        </_ImageHolder>
        <_ListingPrice showLockedStyled={showLockedStyled}>
          <_FormattedPriceSpan closedPrice={closedPrice}>
            {isAskingPriceAvailable ? `${isPreconFloorplan ? 'From ' : ''}${formatPrice(price)}` : 'Contact for pricing'}
          </_FormattedPriceSpan>
          {
            closedPrice && <span>{formatPrice(closedPrice)}</span>
          }
        </_ListingPrice>
        <_ListingTitle
          alt={title}
          openNewTab
          to={'/' + url}
        >
          {isPrecon ? `${title} - ${streetSuffix}` : title}
        </_ListingTitle>
        <_RemoveCta
          aria-label="remove"
          onClick={() => {
            removeCompareListing(listing)
            googleAnalyticsEvent({
              category: COMPARE_GA_CATEGORY,
              action: [
                'Clicked X to Remove Compared Listing On Card',
                `${handleGalleryAndMap ? 'Compare Page' : 'Compare Grid'}`,
              ],
            })
          }}
        >
          <SvgIcon name="#icon-close" width={8} height={8} />
        </_RemoveCta>
      </_InnerCard>
    </_ListingCard>
  )
}

ListingCard.propTypes = {
  listing: PropTypes.shape({
    photo_base_url: PropTypes.string,
    mls_number: PropTypes.string,
    closed_price: PropTypes.number,
    asking_price: PropTypes.number,
    url: PropTypes.string,
    title: PropTypes.string,
    photo_source: PropTypes.string,

    street_name_short: PropTypes.string,
    street_number: PropTypes.string,
    address: PropTypes.shape({
      street_name_short: PropTypes.string,
      street_number: PropTypes.string,
    }),
    offer: PropTypes.string,
    property_type: PropTypes.string,
  }),
  removeCompareListing: PropTypes.func,
  className: PropTypes.string,
  userIsAuthentificated: PropTypes.bool,
  openRegisterModal: PropTypes.func,
  handleGalleryAndMap: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  offer: PropTypes.string,
  property_type: PropTypes.string,
}

export default ListingCard
